<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {

}
</script>

<style>
@font-face {
  font-family: 'Nunito Light';
  font-style: normal;
  font-weight: 100;
  src: local(''),
    url('./fonts/Nunito-Light.ttf') format('truetype');
  unicode-range: U+0030-0039; /* Only Numbers */
}

body {
  font-family: 'Nunito Light','Raleway'!important;
}
</style>
